const theme = {
  fontFamily: "Lato,sans-serif",
  colors: {
    mainBgColor: "#f5f5f5",
    mainDark: "rgb(0, 0, 0)",
  },
  skeleton: {
    backgroundColor: "#dedede",
  },
  sliderTitle: {
    color: "#000",
    fontSize: "16px",
    fontWeight: "700",
    textTransform: "uppercase",
  },
  image: {
    aspectRatio: "3 / 2",
    borderRadius: "4px",
  },
  imageMobile: {
    aspectRatio: "1",
  },
  sliderItemLabel: {
    color: "#606060",
  },
  moreBtn: {
    borderRadius: "0",
    boxSizing: "content-box",
    padding: "0",
    border: "none",
    color: "#be1717",
    fontWeight: "700",
    fontSize: "16px",
    outline: "none",
    cursor: "pointer",
    textDecoration: "none",
    display: "none",
  },
  moreBtnHover: {
    color: "#00ae42",
  },
  sliderHeader: {
    margin: "8px 65px",
  },
  sliderHeaderSmall: {
    margin: "0 35px",
  },
  sliderHeaderMobile: {
    margin: "8px 10px",
  },
  playBtnHighlights: {
    color: "#00ae42",
  },
  slideBtn: {
    backgroundColor: "rgba(240,240,240,0.7)", // always use rgba with opacity 0.7 here
    color: "#000",
  },
};

export default theme;
